import { render } from "./com_ventas_ticket.vue?vue&type=template&id=707fa446&scoped=true"
import script from "./com_ventas_ticket.vue?vue&type=script&lang=js"
export * from "./com_ventas_ticket.vue?vue&type=script&lang=js"

import "./com_ventas_ticket.vue?vue&type=style&index=0&id=707fa446&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707fa446"]])

export default __exports__